<app-toolbar></app-toolbar>
<div class="main-layout content">
  <div class="card-container">
    <div class="card">
      <h1 class="title-card">Help & Support</h1>

      <br />

      <div class="flex">
        <div
          class="info-card"
          (click)="
            onCardClick(
              $event,
              'https://azcollaboration.sharepoint.com/:p:/r/sites/StrategyChangeandResultsTeam/_layouts/15/guestaccess.aspx?share=Ec6y7HMtxBhCkNJfgQJlE0EBXikkeNQQyEr5T0pfJHrD0Q&e=cbRgbs',
              '_blank'
            )
          "
        >
          <img src="../../../../../assets/book.svg" alt="book" />
          <div class="info-text">
            <a
              href="https://azcollaboration.sharepoint.com/:p:/r/sites/StrategyChangeandResultsTeam/_layouts/15/guestaccess.aspx?share=Ec6y7HMtxBhCkNJfgQJlE0EBXikkeNQQyEr5T0pfJHrD0Q&e=cbRgbs"
              target="_blank"
              class="link-title"
              (click)="$event.stopPropagation()"
            >
              <h3>Simulator Guide​</h3>
            </a>
            <p>
              ​Access our step-by-step guide to learn how to navigate the tool,
              take actions, and track your progress throughout the simulation.​
            </p>
          </div>
        </div>

        <div
          class="info-card"
          (click)="
            onCardClick(
              $event,
              'mailto:ChangeManagementC4EIT@astrazeneca.com?subject=CMS Request Support'
            )
          "
        >
          <img src="../../../../../assets/mail.svg" alt="" />
          <div class="info-text">
            <a
              href="mailto:ChangeManagementC4EIT@astrazeneca.com?subject=CMS Request Support"
              class="link-title"
              (click)="$event.stopPropagation()"
            >
              <h3>Contact Us​</h3>
            </a>
            <p>
              Send us an email and our Change Management team will follow up to
              provide support and guidance.​
            </p>
          </div>
        </div>

        <div
          class="info-card"
          (click)="
            onCardClick(
              $event,
              'https://azcollaboration.sharepoint.com/sites/CMV564',
              '_blank'
            )
          "
        >
          <img src="../../../../../assets/hub.svg" alt="" />
          <div class="info-text">
            <a
              href="https://azcollaboration.sharepoint.com/sites/CMV564"
              target="_blank"
              class="link-title"
              (click)="$event.stopPropagation()"
            >
              <h3>Explore our Change Management Hub​</h3>
            </a>
            <p>
              ​Visit our Change Management Hub to explore our services, tools,
              and best practices for driving successful change​.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
